import { FC, ReactNode } from 'react';
import cx from 'classnames';

type Props = {
    verifying: boolean;
    size?: string;
    /**
     * If true, the default background of white at 70% opacity will be used,
     * otherwise pass in a tailwind background colour class.
     */
    background: boolean | string;
};

const LoadingSpinner: FC<Props> = ({ verifying, size = '80px', background = false }) => {
    let Background: ReactNode;
    switch (typeof background) {
        case 'string':
            Background = (
                <div
                    className={`tw-absolute tw-left-0 tw-top-0 tw-z-0 tw-h-[calc(100%+20px)] tw-w-full ${background}`}
                ></div>
            );
            break;
        default:
            if (background === true) {
                Background = (
                    <div
                        className={
                            'tw-absolute tw-left-0 tw-top-0 tw-z-0 tw-h-[calc(100%+20px)] tw-w-full tw-bg-white/70'
                        }
                    ></div>
                );
            }
            break;
    }

    return (
        <div
            className={cx(
                'tw-absolute tw-left-0 tw-z-[2] tw-mb-[-10px] tw-mt-[-10px] tw-h-full tw-w-full tw-items-center tw-justify-center',
                { 'tw-hidden': !verifying },
                { 'tw-flex': verifying }
            )}
        >
            <div
                className={'tw-relative tw-z-[1] tw-inline-block tw-h-[80px] tw-w-[80px]'}
                style={{ width: size, height: size }}
            >
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[36] after:tw-absolute after:tw-left-[63px] after:tw-top-[63px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[72] after:tw-absolute after:tw-left-[56px] after:tw-top-[68px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[108] after:tw-absolute after:tw-left-[48px] after:tw-top-[71px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[144] after:tw-absolute after:tw-left-[40px] after:tw-top-[72px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[180] after:tw-absolute after:tw-left-8 after:tw-top-[71px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[216] after:tw-absolute after:tw-left-[24px] after:tw-top-[68px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[252] after:tw-absolute after:tw-left-[17px] after:tw-top-[63px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
                <div
                    className={`tw-origin-[40px_40px] tw-animate-circle -tw-animation-delay-[288] after:tw-absolute after:tw-left-3 after:tw-top-[56px] after:tw-m-[-4px_0_0_-4px] after:tw-h-[7px] after:tw-w-[7px] after:tw-rounded-[50%] after:tw-bg-teal-600 after:tw-content-['']`}
                ></div>
            </div>
            {Background}
        </div>
    );
};

export default LoadingSpinner;
